import {
  getSavedItemsSummary,
  GetSavedItemsSummaryResponse,
} from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";

type PublicGetSavedItemsSummaryMethod =
  () => Promise<GetSavedItemsSummaryResponse>;
type GetSavedItemsSummaryMethod =
  SavedItemsSdkMethod<PublicGetSavedItemsSummaryMethod>;

export const getSavedItemsSummaryInitializer: GetSavedItemsSummaryMethod =
  ({ getAuthHeaderPredicate, ...context }) =>
  async () => {
    try {
      const response = await getSavedItemsSummary({
        authHeader: await getAuthHeaderPredicate(),
        chameleonRequestInstance: context.chameleonRequestInstance,
        store: context.store,
        keyStoreDataversion: context.keyStoreDataversion,
        shop: context.shop,
        lang: context.lang,
      });

      return response;
    } catch (error) {
      console.error("Error getting saved items:", error);
      throw error;
    }
  };
